import { z } from 'zod';
import { createSortablePaginationSchema, dateFilterSchema } from '../shared/index.js';
/**
 * Schema for searching email audits with pagination and filtering
 */
export const EMAIL_AUDIT_ORDER_BY_FIELDS = ['email', 'sentAt'];
export const emailAuditSearchSchema = createSortablePaginationSchema(EMAIL_AUDIT_ORDER_BY_FIELDS).extend({
    /** Case-insensitive partial match on recipient email */
    email: z.string().optional(),
    /** Exact match filter on template type */
    templateType: z.string().optional(),
    /** Date range filter using gte/lte */
    sentAt: dateFilterSchema.optional(),
});
